<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <template v-if="this.formaPodnikania.pkId == 1 || this.formaPodnikania.pkId == 2">
        <v-card class="mt-24px card">
          <template v-if="this.formaPodnikania.pkId == 1">
            <v-row class="mb-2" no-gutters>
              <v-col>
                <h2 class="left mr-3">Pridanie štatutárov</h2>
              </v-col>
            </v-row>
            <v-row class="mb-2" no-gutters>
              <v-col cols="8">
                <p class="f16 gs100 mb-0">
                  Na zadávanie vzdialeného podpisu musia mať všetci štatutári vytvorený účet v
                  Klientskej zóne a prejsť procesom overenia totožnosti.
                </p>
                <br />
                <p class="f16 gs100 mb-0" style="font-weight: 700">
                  Štatutárom, ktorí nemajú vytvorený účet, príde e-mailom link na registráciu.
                </p>
                <br />
                <p class="f16 gs100 mb-0" style="font-weight: 700">
                  V prípade, že je potrebné pridať profil v Klientskej zóne, je možné tak urobiť po prihlásení kliknutím na rozbaľovacie menu profilu (v pravej hornej časti) a následne kliknutím na „Pridať profil“.
                </p>
                <br />
                <p class="f16 gs100 mb-0" style="font-weight: 700">
                  Konečného uživateľa výhod vyberte zo zoznamu štatutárov. V prípade, že konečný
                  užívateľ výhod nie je štatutárom firmy, pridajte ho cez tlačidlo "Pridať nového
                  KUV".
                </p>
              </v-col>
            </v-row>
            <v-divider></v-divider>
              <template v-for="(user, index) in users">
                <v-row :key="'user-name' + index" class="mt-4 no-padding-top-bottom">
                  <v-col cols="8">
                    <span class="f18 white100">{{ user.meno }} {{ user.priezvisko }}</span>
                    <span
                      v-if="!!user.popis"
                      :class="{ 'sumar-info': user.popisFarba == 0, 'sumar-success': user.popisFarba == 1 ,'sumar-warning': user.popisFarba == 2}"
                      class="ml-2"
                    >
                      <v-icon
                        class="btn-help"
                        size="16px"
                        :class="{ 'sumar-info': user.popisFarba == 0, 'sumar-success': user.popisFarba == 1,'sumar-warning': user.popisFarba == 2 }"
                        >$check_circle
                      </v-icon>
                      {{
                        user.popis
                      }}</span
                    >
                  </v-col>
                </v-row>

                <v-row :key="'user' + index" class="mt-2 no-padding-top-bottom">
                  <v-col cols="4">
                    <v-text-field
                      v-model="users[index].email"
                      label="E-mail"
                      class="dynamic-input-control required"
                      :rules="[rules.email, rules.required]"
                      outlined
                      :disabled="!user.emailEnabled"
                      @change="dirty=true"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete
                      :items="vztahyKFirme"
                      label="Vzťah k firme"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      item-text="displayMember"
                      item-value="valueMember"
                      v-model="users[index].funkcia"
                      :disabled="!!user.popis"
                      @change="dirty=true"
                    />
                  </v-col>
                </v-row>
                <v-row :key="'konecny-uzivatel' + index" class="mb-4" no-gutters>
                  <v-col cols="4">
                    <v-checkbox
                      class="dynamic_check_box mt-0"
                      label="Konečný užívateľ výhod"
                      v-model="users[index].kuv"
                      @change="dirty=true"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </template>
            <v-divider></v-divider>
          </template>
          <template v-if="this.formaPodnikania.pkId == 2">
            <v-row class="mb-2" no-gutters>
              <v-col>
                <h2 class="left mr-3">Konečný užívateľ výhod</h2>
              </v-col>
            </v-row>
            <v-row class="mb-2" no-gutters>
              <v-col cols="8">
                <p class="f16 gs100 mb-0">
                  Pred odoslaním ponuky na schválenie skontrolujte zadaného konečného užívateľa výhod (KUV). <br />
                  V prípade, ak je KUV aj iná osoba, pridajte ho pomocou tlačidla “Pridať nového KUV”.
                </p>
              </v-col>
            </v-row>
            <template v-for="(user,index) in users">
              <v-row class="mt-8" :key="'user' + index">
                <v-col cols="3">
                  <v-text-field
                    :value="user.meno + ' ' + user.priezvisko"
                    :label="'Konečný užívateľ výhod'"
                    class="dynamic-input-control mb-10px"
                    disabled
                    hide-details
                    outlined
                  />
                </v-col>
              </v-row>
            </template>
          </template>
          <template v-for="(user, index) in kuv"> 
            <v-card :key="'kuv' + index" class="mt-4 dialog-card card-item gap-4 pa-4">
              <v-row no-gutters>
                <v-col cols="4" class="pr-2">
                  <v-text-field
                    v-model="kuv[index].meno"
                    label="Meno"
                    class="dynamic-input-control required"
                    :rules="[rules.required]"
                    outlined
                    @change="dirty=true"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="4" class="ml-2 pl-2">
                  <v-text-field
                    v-model="kuv[index].priezvisko"
                    label="Priezvisko"
                    class="dynamic-input-control required"
                    :rules="[rules.required]"
                    outlined
                    @change="dirty=true"
                  >
                  </v-text-field>
                </v-col>
                <v-btn
                  style="margin-left: auto"
                  @click="deleteKUV(index)"
                  class="pa-0 predmet-expand btn-secondary btn-icon"
                >
                  <v-icon>$trash</v-icon>
                </v-btn>
              </v-row>

              <v-row :key="'user' + index" no-gutters>
                <v-col cols="4" class="pr-1">
                  <DatePicker
                    class="required"
                    label="Dátum narodenia"
                    hide-error-icon
                    placeholder="DD/MM/YYYY"
                    :rules="[rules.required]"
                    v-model="kuv[index].datumNarodenia"
                    required
                    @change="dirty=true"
                  />
                </v-col>
                <v-col cols="4" class="ml-2 pl-2">
                  <v-text-field
                    v-model="kuv[index].rodneCislo"
                    label="Rodné číslo"
                    class="dynamic-input-control required"
                    :rules="getRulesRodCislo(user)"
                    @input="v => onRodneCisloInput(v, user)"
                    outlined
                    @change="dirty=true"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="4" class="pr-2">
                  <v-checkbox
                    style="white-space: nowrap; margin-top: 0px"
                    v-bind:class="{
                      dynamic_check_box: true
                    }"
                    label="Zahraničná osoba"
                    v-model="kuv[index].zahranicnaOsoba"
                    hide-details
                    @change="dirty=true"
                  />
                </v-col>
              </v-row>
            </v-card>
          </template>
          <v-row class="mt-4" no-gutters>
            <v-col cols="4">
              <v-btn class="btn-secondary" @click="addKUV()"
                ><v-icon class="text-body-2">mdi-plus</v-icon> Pridať nového KUV</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </template>
      <template v-else>
        <DodatocneInfoScoringForm
          v-if="dlznik.length > 0"
          :spoludlznik="false"
          :value="dlznik"
          :cislo_plz="variant.cislo_plz"
          ref="dlznik"
          key="dlznik"
          @changeDirty="()=> dirty = true"
          @checkRequireSpoludlznik="(val) => checkRequireSpoludlznik(val)"
        />
        <v-card class="mt-24px card" v-if="!jeSpoludlznik">
          <v-row class="mb-4">
            <v-col>
              <h2 class="left mr-3">Spolužiadateľ</h2>
            </v-col>
          </v-row>
          <v-row class="mt-8">
            <v-col cols="4" style="align-self: end">
              <v-checkbox
                style="white-space: nowrap; margin-top: 0px"
                v-bind:class="{
                  dynamic_check_box: true,
                }"
                label="Chcem pridať spolužiadateľa"
                v-model="pridanieSpoludlznika"
                @change="dirty=true"
                :disabled="requiredSpoludlznik"
              />
            </v-col>
          </v-row>
          <v-row v-if="pridanieSpoludlznika">
            <v-col cols="8" style="align-self: end">
              <span class="sumar-dodat-info-label"
                >Pred odoslaním ponuky na schválenie je potrebné, aby mal spolužiadateľ vytvorený účet 
                a overenú totožnosť. Link na registráciu zašleme spolužiadateľovi e-mailom.</span
              >
            </v-col>
          </v-row>
          <v-row class="mt-4" v-if="pridanieSpoludlznika">
            <v-col cols="4" style="align-self: end">
              <v-text-field
                v-model="emailSpoludlznika"
                label="E-mail spolužiadateľa"
                class="dynamic-input-control required"
                :rules="[rules.email, rules.required]"
                outlined
                @change="onChangeEmailSpoludlznika"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <DodatocneInfoScoringForm
          v-if="jeSpoludlznik || (spoludlznik.length > 1 && pridanieSpoludlznika && jeDealer())"
          :spoludlznik="true"
          :value="spoludlznik"
          :cislo_plz="variant.cislo_plz"
          ref="spoludlznik"
          key="spoludlznik"
          @changeDirty="()=> dirty = true"
        />
      </template>
    </v-form>
    <!-- <v-dialog
      v-model="dialog"
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      eager
      max-width="500"
    >
      <v-card class="dialog-card">
        <v-card-title class="d-flex justify-space-between">
          <span class="f16"> Odoslať na schválenie </span>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="">
          <template v-if="formaPod == 1">
            <span class="gs100 f16" v-if="newUsers.length > 0">
              Ponuka bude odoslaná na schválenie po úspešnom prihlásení štatutárov. Jeho priebeh si
              môžete pozrieť v záložke Dodatočné informácie.
            </span>
            <span class="gs100 f16" v-else>
              Ponuka bola úspešne odoslaná na schválenie. O výsledku schvaľovacieho procesu vás
              informujeme e-mailom.
            </span>
          </template>
          <template v-if="formaPod == 3">
            <span class="gs100 f16">
              Ponuka bude odoslaná na schválenie po úspešnom prihlásení spoludlžníka.
            </span>
          </template>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>
<script>
import CheckBox from '../basic/CheckBox.vue';
import DatePicker from '../basic/DatePicker.vue';
import NumericTextBox from '../basic/NumericTextBox.vue';
import protectedAxios from '../../auth/axios';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { eventBus } from '../../main';
import DodatocneInfoScoringForm from '../sumar/DodatocneInfoScoringForm.vue';
// import { pripadLinkMixin } from '../../mixins/pripadLinkMixin';

export default {
  props: {
    menu: Array,
    pravoNaAdresnuPonuku: Boolean,
    formaPodnikania: Object, //1-PO , 2-FOP , 3-FON
    variant: {
      type: Object,
      default: null
    },
    tab: Number
  },
  components: {
    CheckBox,
    DatePicker,
    NumericTextBox,
    DodatocneInfoScoringForm
  },
  data: () => ({
    // dialog: 0,
    dirty: false,
    jeSpoludlznik: false,
    uzivatelVyhod: {
      pkid: null,
      meno: 'Helena Bystrá',
    },
    rules: {
      email: value => {
        if (!value) return true;
        if (
          //podla RFC 5322
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            value
          )
        )
          return true;
        else return 'Nesprávny formát e-mailovej adresy';
      },
      rodCislo: value => {
        if (!value) return true;
        if (value.length === 9 && /^[0-9]{6}[0-9]{3}$/.exec(value) && value.substring(0, 2) < 54)
          return true;
        if (value.length === 10 && /^[0-9]{6}[0-9]{4}$/.exec(value) && value % 11 === 0)
          return true;
        else return 'Zadané rodné číslo je nesprávne!';
      },
      required: value => {
        return !!value || value === 0 || 'Povinné pole';
      },
    },
    users: [],
    kuv: [],
    vztahyKFirme: [],
    pridanieSpoludlznika: false,
    requiredSpoludlznik: false,
    existDBSpoludlznik: false,
    emailSpoludlznika: '',
    changeEmailSpoludlznika: false,
    isScoringLoaded: false,
    dlznik:[],
    spoludlznik: [],
  }),
  computed: {
    ...mapState(['pripad']),
    // ...mapGetters(['odoslatNaSchvalenieRequest']),
  },
  watch: {
      tab(value) {
        if (value == 2) {
          this.dirty = true;
        }
      },
    },
  methods: {
    ...mapMutations(['openDialog','setLoadingDialog']),
    // Tu v pripad.cislo_plz by mohlo byt inicializované
    //...mapGetters(['pripad']),
    ...mapGetters(['jeDealer']),
    getStatutary(){
      return protectedAxios.get(`sumarDodatInf/statutary-${this.formaPodnikania.skratka}?newId=${this.pripad.newId}`)
        .then(res => {
        this.users = res.data;
      })
    },
    addUzivatelVyhod() {
      //call api pridanie noveho Uzivatela vyhod
      console.log('pridanie uzivatela vyhod');
    },
    addKUV() {
      this.kuv.push({ 
        iDZak: this.users[0]?.idZakakaznika ?? null,
        idZastupcu: -1,
        meno: "",
        priezvisko: "",
        datumNarodenia: null,
        rodneCislo: null,
        zahranicnaOsoba: false
     });
    },
    getKuv(){
      return protectedAxios.get(`sumarDodatInf/kuv?newId=${this.pripad.newId}`)
      .then(res => {
        this.kuv = res.data;
      })
    },
    deleteKUV(index) {
      this.dirty = true;
      if(this.kuv[index].idZak != null && this.kuv[index].idZastupcu != null){
        return protectedAxios.delete(`sumarDodatInf/kuv/${this.pripad.newId}/${this.kuv[index].idZak}/${this.kuv[index].idZastupcu}`).then(res => {
          return this.getKuv();
        })
      }else{
        this.kuv.splice(index, 1);
      }
    },
    async saveData() {
      let error = false;
      if (this.$refs['form'].validate()) {
        let _dialog = {
          persistent: true,
          header: `<span class="f16"> Odoslať na schválenie </span>`,
          closeIcon: {
            value: true,
          },
          text: ``,
        };

        if (this.formaPodnikania.pkId == 1) {
          if (!this.isKuvUser()) {
            _dialog.text = `<span class="gs100 f16">
              Vyberte alebo pridajte konečného užívateľa výhod.
            </span>`;
            error = true;
            this.openDialog(_dialog);
          } else {
            this.setLoadingDialog({open:true,btext:'Prebieha proces ukladania dodatočných informácií...',utext:'Proces môže trvať aj niekoľko sekúnd'});
            await this.saveStatutary().then(async ()=>{
              if (this.kuv.length > 0) {
                await this.saveKUV()
              }
            })
          }
        }
        
        if (this.formaPodnikania.pkId == 2) {
          if (!this.isKuvUser()) {
            _dialog.text = `<span class="gs100 f16">
              Vyberte alebo pridajte konečného užívateľa výhod.
            </span>`;
            error = true;
            this.openDialog(_dialog);
          } else {
            this.setLoadingDialog({open:true,btext:'Prebieha proces ukladania dodatočných informácií...',utext:'Proces môže trvať aj niekoľko sekúnd'});
            await protectedAxios.get(`sumarDodatInf/fopovereny?newId=${this.pripad.newId}`);
            if (this.kuv.length > 0) {
              await this.saveKUV()
            } 
          }
        }
        if (this.formaPodnikania.pkId == 3) {
          this.setLoadingDialog({open:true,btext:'Prebieha proces ukladania dodatočných informácií...',utext:'Proces môže trvať aj niekoľko sekúnd'});
          error = !await this.saveScoring()
        }
      }else{
        error = true;      
      }
      if(error){
        if(this.tab != 2)
          this.$emit("sumarChangeTab",2);
          this.$nextTick(() => {
          const firstInvalidField = this.$el.querySelector('.v-input.error--text');
          if(firstInvalidField != null){
            this.$vuetify.goTo(firstInvalidField, { duration: 500, easing: 'easeInOutCubic' ,offset: 150});
          }
          this.$emit("setValid",{value: true, property: 'formValid', message: "Prosím vyplňte všetky povinné polia!", showProgress: false, isError: true});
        });
      }else{
        this.loadData();
        this.dirty= false;
      }
      this.setLoadingDialog();
      return error;
    },
    // ak mame oznacene KUV checkbox alebo je pridana KUV osoba
    isKuvUser(){
      const usersHasKuv = this.users.some(user => user.kuv);
      if (usersHasKuv) { return true; }
      return this.kuv.length > 0;
    },
    async saveKUV(){
      return await protectedAxios.post('sumarDodatInf/ulozKUV',{model: this.kuv, newId: this.pripad.newId}).then(res => {
        return res.data;
      })
    },
    async saveStatutary(){
      const users = this.users.map(user => {
        return {
            ...user,      
            kuv: user.kuv ? 1 : 0 
        };
      });
      return await protectedAxios.post('sumarDodatInf/UlozStatutarPO',{model: users, newId: this.pripad.newId}).then(res => {
        return res.data;
      })
    },
    getFunkcie(){
      return protectedAxios.get(`cis/funkcie`).then(res => this.vztahyKFirme = res.data);
    },
    onRodneCisloInput(v, user) {
      if (!user.zahranicna_osoba) {
        const rdcObj = this.parseRdc(v);
        if(v?.length > 5)
          user.datumNarodenia = rdcObj.datum;
      }
    },
    parseRdc(rdc) {
      const obj = { datum: null, pohlavie: null };
      const koncovka = rdc.substring(6, 12);
      const y = rdc.substring(0, 2);
      const m = rdc.substring(2, 4);
      const d = rdc.substring(4, 6);

      let datum = '';

      if (koncovka.length === 3) datum += '19';
      else if (koncovka.length === 4 && Number(y) >= 54) datum += '19';
      else datum += '20';
      datum += y;
      datum += '-';
      if (m.charAt(0) === '5') datum += '0' + m.charAt(1);
      else if (m.charAt(0) === '6') datum += '1' + m.charAt(1);
      else datum += m;
      datum += '-';
      datum += d;

      obj.pohlavie = Number(m) > 50 ? 2 : 1;
      obj.datum = datum;

      return obj;
    },
    getRulesRodCislo(user){
      let rodCisloRules = [this.rules.required];
      if(!user.zahranicnaOsoba)
        rodCisloRules.push(this.rules.rodCislo)
      return rodCisloRules;
    },
    // Dokončiť
    async saveScoring() {
      //var cislo_plz = '164000009000';
      this.$emit("setValid",{value: false, property: 'formValid', message: '', showProgress: false, isError: true});
      let scoringParametre = [];
      let errorText = null;
      if(this.dlznik.length > 0){
        let dlznikData = this.$refs.dlznik.saveScoring();
        if(dlznikData.error.length > 0){
          errorText = dlznikData.error;
        }else{
          scoringParametre.push(...dlznikData.data)
        }
      }
      if((this.jeDealer() && this.pridanieSpoludlznika ) || this.jeSpoludlznik){
        if(this.spoludlznik.length > 0){
          let spoludlznikData = this.$refs.spoludlznik.saveScoring();
          if(errorText == null){
            if(spoludlznikData.error.length > 0){
              errorText = spoludlznikData.error;
            }else{
              scoringParametre.push(...spoludlznikData.data)
            }
          }
        }
      }

      if(errorText != null){
        console.log(errorText);
        this.$nextTick(() => {
          const firstInvalidField = this.$el.querySelector('.v-input.error--text');
          console.log(firstInvalidField);
          if(firstInvalidField != null){
            this.$vuetify.goTo(firstInvalidField, { duration: 500, easing: 'easeInOutCubic' ,offset: 150});
          }
          this.$emit("setValid",{value: true, property: 'formValid', message: errorText, showProgress: false, isError: true});
          return false;
        })
      }else{
        return await protectedAxios.post(`/sumar/scoring`, {
          CisloPlz: this.variant.cislo_plz,
          ScoringParameters: scoringParametre
        }).then(async res => {
          if(this.pridanieSpoludlznika){
            if(this.changeEmailSpoludlznika || !this.existDBSpoludlznik){
              if(this.emailSpoludlznika){
                await protectedAxios.post(`/sumarDodatInf/email-spoludlznika`, {
                  NewId: this.pripad.newId,
                  Email: this.emailSpoludlznika
                })
              }
            }
          }else{
            if(this.existDBSpoludlznik){
              await protectedAxios.post(`/sumarDodatInf/email-spoludlznika`, {
                NewId: this.pripad.newId,
                Email: null
              })
            }
          }
          this.$emit('reloadSpoludlznik');
          return true;
        }).catch(error => {
          console.error(error);
          return false;
        });
      }
    },
    async checkRequireSpoludlznik(check){
      if(check){
        if(this.existDBSpoludlznik){
          this.requiredSpoludlznik = true;
        }else{
          await protectedAxios.get(`/sumar/check-require-spoludlznik?cisloPlz=${this.variant.cislo_plz}`).then(async res => {
            if (res.data == 1) {
              this.requiredSpoludlznik = true;
              this.pridanieSpoludlznika = true;
            }else{
              this.requiredSpoludlznik = false;
            }
          }).catch(e => {
            console.error(e);
            eventBus.$emit('snack-error', 'Pri kontrole nutnosti spolužiadateľa nastala chyba: ' + e);
          })
        }
      }else{
        if(!this.existDBSpoludlznik){
          this.requiredSpoludlznik = false;
        }else{
          this.requiredSpoludlznik = true;
        }
      }  
    },
    async loadScoring(cislo_plz) {
      this.dlznik = [];
      this.spoludlznik = [];
      await protectedAxios.get(`/sumar/scoring?cisloPlz=${cislo_plz}`).then(async res => {
        if (res.data.length > 0) {
          const result = res.data.reduce(
            (acc, item) => {
              if (item.je_spoludlznik) {
                acc.spoludlznik.push(item);
              } else {
                acc.dlznik.push(item);
              }
              return acc;
            },
            { dlznik: [], spoludlznik: [] }
          );
          await this.getEmailSpoludlznika();          
          
          this.dlznik = result.dlznik;
          if(this.dlznik.length > 0){
            let rodinnyStav = this.dlznik.find(item => item.id_category == 9800);
            if(rodinnyStav){
              this.checkRequireSpoludlznik(rodinnyStav.control_value == 2);
            }
          }
          this.spoludlznik = result.spoludlznik;
          
          this.jeSpoludlznik = this.spoludlznik.length > 1 && !this.jeDealer();

          this.isScoringLoaded = true;
        }
      }).catch(e => {
        console.error(e);
        eventBus.$emit('snack-error', 'Pri načítaní dodatočných informácií nastala chyba: ' + e);
      })
    },
    onChangeEmailSpoludlznika(){
      this.dirty = true;
      this.changeEmailSpoludlznika = true;
      this.emailSpoludlznika
    },
    async getEmailSpoludlznika(){
      return await protectedAxios.get(`/sumarDodatInf/email-spoludlznika?newId=${this.pripad.newId}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          if (res.data.length > 0) {
            this.emailSpoludlznika = res.data[0];
            this.pridanieSpoludlznika = true;
            this.existDBSpoludlznik = true;
            this.requiredSpoludlznik = true;
          }
        })
    },
    reloadSpoludlznik(){
      if(this.formaPodnikania.pkId == 3)
      this.getEmailSpoludlznika();
    },
    loadData(){
      //1-PO , 2-FOP , 3-FON
      switch(this.formaPodnikania.pkId){
        case 1:
          this.getStatutary()
          this.getKuv()
          break;
        case 2:
          this.getStatutary()
          this.getKuv()
          break;
        case 3:
          // Tu dať cislo_plz
          //this.loadScoring('164000009000');
          this.loadScoring(this.variant.cislo_plz);
          break;
        default:
         eventBus.$emit('snack-error', 'Forma podnikania nie je načítaná!');
      }
    }
  },
  created() {
      this.getFunkcie();
      this.loadData();
    // protectedAxios
    //   .get(`sumar/najomca?cisloObchPripadu=${this.pripad.cislo}`, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .then(res => {
    //     if (res.data.length > 0) {
    //       this.najomca = res.data[0];
    //     }
    //   })
    //   .catch(e => {
    //     console.error(e);
    //   });
  },
};
</script>
